module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_2.b03aef59.png";